import { provider } from "@grassrootly/api/providers";
import { IUser } from "../../entities";

export type AuthMePayload = {
  access_token: string;
};

export const AuthMe = async (params: AuthMePayload): Promise<IUser> =>
  provider.Request<AuthMePayload, IUser>("/auth/me", params);
